import {
  Alert,
  AlertContent,
  AlertTitle,
  ShellIconAlertCircle,
  ShellIconAlertTriangle,
  ShellIconCheckCircle,
  ShellIconInfo,
} from '@zrsystem/ui';
import type { ReactNode } from 'react';

export type ContextualFeedbackVariant = 'info' | 'success' | 'warning' | 'danger';

export interface ContextualFeedbackProps {
  variant: ContextualFeedbackVariant;
  title?: ReactNode;
  children?: ReactNode;
  message?: ReactNode;
  action?: ReactNode;
  className?: string;
}

const ICONS = {
  info: ShellIconInfo,
  success: ShellIconCheckCircle,
  warning: ShellIconAlertTriangle,
  danger: ShellIconAlertCircle,
} as const;

export function ContextualFeedback({
  variant,
  title,
  children,
  message,
  action,
  className,
}: ContextualFeedbackProps) {
  const Icon = ICONS[variant];
  const body = children ?? message;

  return (
    <Alert variant={variant} className={className}>
      <Icon size={16} />
      <AlertContent>
        {title ? <AlertTitle>{title}</AlertTitle> : null}
        {body}
        {action}
      </AlertContent>
    </Alert>
  );
}
